import { IListLocation } from '@/types/components/location';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

const locationInitial: IListLocation = {
  shop: '',
  id: -1,
  shopifyLocationId: '',
  isActive: true,
  deletable: true,
  activatable: true,
  isEnablePickup: false,
  isEnableDelivery: false,
  name: '',
  updatedAt: '',
  createdAt: '',
  address: {
    country: '',
    countryCode: '',
    city: '',
    province: '',
    provinceCode: '',
    postalCode: '',
    address1: '',
    address2: '',
    phone: '',
    longitude: '',
    latitude: '',
  },
  settings: [],
  position: 0,
};

const initialState = {
  locationSetting: locationInitial,
  locationBackupSetting: locationInitial,
  isChangeData: false,
  isOpenDiscardModal: false,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    handleSaveLocationSettings: (state, action: PayloadAction<Partial<IListLocation>>) => {
      state.locationSetting = { ...state.locationSetting, ...action.payload };
    },
    handleSaveBackupLocationSettings: (state, action: PayloadAction<Partial<IListLocation>>) => {
      state.locationBackupSetting = { ...state.locationBackupSetting, ...action.payload };
    },
    handleSetIsChangeData: (state, action: PayloadAction<boolean>) => {
      state.isChangeData = action.payload;
    },
    handleToggleDiscardModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenDiscardModal = action.payload;
    },
    handleResetLocationSettings: (state) => {
      state.locationSetting = state.locationBackupSetting;
      state.isChangeData = false;
      state.isOpenDiscardModal = false;
    },
  },
});

export const locationSettingSelector = createSelector(
  (state: RootState) => state.location,
  (state) => state.locationSetting,
);
export const backupLocationSettingSelector = createSelector(
  (state: RootState) => state.location,
  (state) => state.locationBackupSetting,
);
export const isChangeDataSelector = createSelector(
  (state: RootState) => state.location,
  (state) => state.isChangeData,
);
export const isOpenDiscardModalSelector = createSelector(
  (state: RootState) => state.location,
  (state) => state.isOpenDiscardModal,
);

export const {
  handleSaveLocationSettings,
  handleSaveBackupLocationSettings,
  handleResetLocationSettings,
  handleSetIsChangeData,
  handleToggleDiscardModal,
} = locationSlice.actions;

export default locationSlice;
